import type {
  WalletMovementKind,
  WalletMovementKindSlug
} from './types'

export const WALLET_MOVEMENT_KINDS: WalletMovementKind[] = [
  { slug: 'deposit', name: 'Ganho', badgeVariant: 'success' },
  { slug: 'withdraw', name: 'Perda', badgeVariant: 'danger' }
]

export const getWalletMovementKind = (
  slug: string | undefined | null
): WalletMovementKind | undefined => {
  if (!slug) return undefined
  return WALLET_MOVEMENT_KINDS.find(kind => kind.slug === slug)
}

export const isWalletMovementKindSlug = (
  slug: string
): slug is WalletMovementKindSlug =>
  WALLET_MOVEMENT_KINDS.some(kind => kind.slug === slug)

export const icon = 'wallet'

export const humanName = {
  singular: 'Extrato de recompensa',
  plural: 'Extrato de recompensas'
} as const
